import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  CreateCompanyGroupRequest,
  CreateCompanyGroupResponse,
  DeleteCompanyGroupResponse,
  FetchCompanyGroupResponse,
  FetchCompanyGroupsResponse,
  UpdateCompanyGroupRequest,
  UpdateCompanyGroupResponse,
  FetchPortfoliosResponse,
} from '../../../../types/b2tRatibiPlus';
import { ApiResponse, PaginatedRequest } from '../../../../types/api';
import { b2bThriftPlan } from '../../../../api/b2bThriftPlan';

export const fetchCompanyGroups = createAsyncThunk<
  FetchCompanyGroupsResponse,
  { companyId: number } & PaginatedRequest
>('companyGroup/fetch-all', async (params) => {
  const response = await b2bThriftPlan.fetchCompanyGroups(params);
  return response;
});

export const fetchCompanyGroup = createAsyncThunk<FetchCompanyGroupResponse, { companyId: number; groupId: number }>(
  'companyGroup/fetch-one',
  async ({ companyId, groupId }) => {
    const response = await b2bThriftPlan.fetchCompanyGroup(companyId, groupId);
    return response;
  },
);

export const createCompanyGroup = createAsyncThunk<
  CreateCompanyGroupResponse,
  { companyId: number; payload: CreateCompanyGroupRequest }
>('companyGroup/create', async ({ companyId, payload }) => {
  const response = await b2bThriftPlan.createCompanyGroup(companyId, payload);
  return response;
});

export const updateCompanyGroup = createAsyncThunk<
  UpdateCompanyGroupResponse,
  { companyId: number; groupId: number; payload: UpdateCompanyGroupRequest }
>('companyGroup/update', async ({ companyId, groupId, payload }) => {
  const response = await b2bThriftPlan.updateCompanyGroup(companyId, groupId, payload);
  return response;
});

export const deleteCompanyGroup = createAsyncThunk<DeleteCompanyGroupResponse, { companyId: number; groupId: number }>(
  'companyGroup/delete',
  async ({ companyId, groupId }) => {
    const response = await b2bThriftPlan.deleteCompanyGroup(companyId, groupId);
    return response;
  },
);

export const uploadCompanyGroupsCsv = createAsyncThunk<ApiResponse, { companyId: number; file: File }>(
  'companyGroup/upload-csv',
  async ({ companyId, file }) => {
    const response = await b2bThriftPlan.uploadCompanyGroupsCsv(companyId, file);
    return response;
  },
);

export const fetchPortfolios = createAsyncThunk<FetchPortfoliosResponse, PaginatedRequest>(
  'portfolio/fetch-all',
  async (params) => {
    const response = await b2bThriftPlan.fetchPortfolios(params);
    return response;
  },
);
